export const MAX_CHECKLISTS = 3
export const MAX_CHECKLIST_NAME_LENGTH = 150
export const MAX_CHECKLIST_POINT_TEXT_LENGTH = 150
export const CHECKLIST_TRANSFER_TYPE = {
  COPY: 'copy',
  MOVE: 'move',
}
